import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//models

//services

//component
import { AuthenticatedComponent} from "../../../../../shared/components/AuthenticatedComponent";
import {number} from "ng2-validation/dist/number";
import {MenuService, SectionService} from "../../../../services/menu.service";
import {BsModalRef} from "ngx-bootstrap";
@Component({
	selector: 'app-section-modal',
	templateUrl: './importMenuItems-modal.component.html',
	styleUrls: ['./importMenuItems-modal.component.scss']
})

export class ImportMenuItemsModalComponent extends AuthenticatedComponent implements OnInit {

	constructor(public sectionService:SectionService,public bsModalRef:BsModalRef){
		super();
	}
  @Input() sectionId: number;
  @Input() menuId: number;
  file:any = null;
  clicked: boolean=false;
	ngOnInit() {

	}
  public import()
  {
    this.sectionService.Import(this.file,this.sectionId,this.menuId).subscribe(data=>
    {
      this.clicked=false;
      if (!data.hasError)
      {
        this.alertService.showSuccess(this.translate.instant("alerts.IMPORTEDSUCCESSFULLY"));
        this.bsModalRef.hide();
      }
      else{
        let errors = data.errors.map(r => {return r.message});
        this.alertService.showError(errors);
      }
    })
  }
}
